import React from 'react';
import { setMainHeader } from 'hb-redux-store/initial.action';
import { connect } from 'react-redux';
import { getBlogsBySegment } from 'hb-redux-store/feature/blog/blog.action';
import './blog.scss';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import WebFooter from '../footer';
import MwebFooter from '../../mweb/Footer/Footer';
import BlogCard from '../../web/Blogs/BlogCard';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import BlogNav from './BlogNav';

class BlogSegments extends React.Component {
  componentDidMount() {
    const deviceType = getDeviceType();
    this.isDesktop = deviceType === DEVICE_TYPE.DESKTOP;
    if (this.isDesktop) this.props.setMainHeader(false);

    const { subcategoryId } = this.props.match.params;
    this.props.getBlogsBySegment({ subcategoryId });
  }

  componentWillUnmount() {
    if (this.isDesktop) this.props.setMainHeader(true);
  }

  render() {
    const { loading, segment } = this.props;
    // console.log('Loading: ', loading);
    // console.log('blog: ', segment);
    return (
      <div className="blog-segment-list">
        {loading && <Loader />}
        {!loading && segment?.sectionTypeBlogsResponse?.length > 0 && (
          <React.Fragment>
            {!this.isDesktop && <BlogNav />}
            <div className="blog-segment-list--title">{segment.header}</div>
            <div className="blog-segment-list--segment-blogs">
              {segment.sectionTypeBlogsResponse.map(blog => {
                if (this.isDesktop)
                  return (
                    <div className="blog-segment-list--blog" key={blog.blogId}>
                      <BlogCard blog={blog} />
                    </div>
                  );
                return (
                  <BlogCard
                    blog={blog}
                    source="segment-pdp"
                    key={blog.blogId}
                  />
                );
              })}
            </div>
            {this.isDesktop ? <WebFooter /> : <MwebFooter />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ blogReducer }) => ({
  loading: blogReducer.loading,
  segment: blogReducer.segment,
});
const mapDispatchToProps = {
  setMainHeader,
  getBlogsBySegment,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogSegments);
